"use strict";

exports.__esModule = true;
exports["default"] = createFormatNumber;

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_LANG = 'en';
var FILE_NAMES = {
  cs: 'cs',
  da: 'da-dk',
  de: 'de',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  nl: 'nl-nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt-pt',
  ru: 'ru',
  th: 'th',
  tr: 'tr'
};

function createFormatNumber(lang) {
  var numeralData;

  try {
    numeralData = require("numeral/languages/" + FILE_NAMES[lang]);
  } catch (e) {}

  if (lang !== DEFAULT_LANG && !numeralData) {
    return function (value) {
      return value;
    };
  }

  _numeral["default"].language(lang, numeralData);

  return function (value) {
    return (0, _numeral["default"])(value).format();
  };
}